import request from "../utils/request";
import { REACT_APP_PAGESIZE, ASSET_SOURCE } from "../config";
const paging = (pageindex, pagesize) => {
  if (!pagesize) {
    return `pageindex=${pageindex}&pagesize=${REACT_APP_PAGESIZE}`;
  }
  return `pageindex=${pageindex}&pagesize=${pagesize}`;
};

export default {
  createSite: (name, longitude, latitude, notes) =>
    request.post(`/sites`, { name, longitude, latitude, notes }),
  updateSite: (key, name, longitude, latitude, notes) =>
    request.put(`/sites/${key}`, { name, longitude, latitude, notes }),
  getSites: () => request.get(`/sites`),
  getSite: key => request.get(`/sites/${key}`),
  getSiteEvents: (key, pageindex, pagesize) =>
    request.get(`sites/${key}/events?${paging(pageindex, pagesize)}`),
  getAssetsBySite: (key, pageindex, pagesize) =>
    request.get(`sites/${key}/assets?${paging(pageindex, pagesize)}`),

  createAsset: (name, encoding, hash, site, file, phone) => {
    let formData = new FormData();
    formData.append("name", name);
    formData.append("encoding", encoding);
    formData.append("hash", hash);
    formData.append("site", site);
    formData.append("file", file);
    formData.append("phone", phone);
    formData.append("source", ASSET_SOURCE);
    return request.post(`/assets`, formData);
  },
  importAssets: (site, file) => {
    let formData = new FormData();
    formData.append("site", site);
    formData.append("file", file);
    formData.append("source", ASSET_SOURCE);
    return request.post(`/assets/import`, formData);
  },
  getAsset: key => request.get(`/assets/${key}`),
  getAssets: (pageindex, pagesize) =>
    request.get(`/assets?${paging(pageindex, pagesize)}`),
  updateAsset: (key, name, encoding, hash, site, file, phone) => {
    let formData = new FormData();
    formData.append("name", name);
    formData.append("encoding", encoding);
    formData.append("hash", hash);
    formData.append("site", site);
    formData.append("file", file);
    formData.append("phone", phone);
    return request.put(`/assets/${key}`, formData);
  },
  getAssetEvents: (key, pageindex, pagesize) =>
    request.get(`/assets/${key}/events?${paging(pageindex, pagesize)}`),

  logEvent: (asset, site, type, value) =>
    request.post(`/events`, { asset, site, type, value }),
  getEvent: key => request.get(`/events/${key}`),
  getEvents: (pageindex, pagesize) =>
    request.get(`/events?${paging(pageindex, pagesize)}`),

  createCampaign: (name, notes, site, start_date, end_date, assets) =>
    request.post(`/campaigns`, {
      name,
      notes,
      site,
      start_date,
      end_date,
      assets
    }),
  updateCampaign: (key, name, notes, site, start_date, end_date) =>
    request.put(`/campaigns/${key}`, {
      name,
      notes,
      site,
      start_date,
      end_date
    }),
  getCampaigns: () => request.get(`/campaigns`),
  getCampaignsBySite: key => request.get(`/campaigns/sites/${key}`),
  getCampaign: key => request.get(`/campaigns/${key}`),
  getCampaignItem: key => request.get(`/campaigns/items/${key}`),
  bulkSendSMSViaCampaign: key => request.post(`/campaigns/${key}/sms/send`),
  sendSMSViaCampaignItem: key =>
    request.post(`/campaigns/items/${key}/sms/send`),
  createCampaignItem: (key, asset) =>
    request.post(`/campaigns/${key}/items`, { asset }),
  removeCampaignItem: key => request.delete(`/campaigns/items/${key}`)
};
